import React from "react";
import BlogFooterEmail from "./BlogFooterEmail";
type Link = {
  href: string;
  text: string;
};
const links: Link[] = [{
  href: "/ask.html",
  text: "Contact"
}, {
  href: "/aboutus.html",
  text: "About Us"
}, {
  href: "/plus/",
  text: "WebstaurantPlus"
}];
const LinkList = ({
  links = []
}: {
  links: Link[];
}) => <div className="flex items-center" data-sentry-component="LinkList" data-sentry-source-file="index.tsx">
    {links.map(link => <React.Fragment key={link.href}>
        {link !== links[0] && <span className="align-middle mx-1 mt-0.5">•</span>}
        <a href={link.href} className="font-bold text-base text-center text-green-600 hover:underline">
          {link.text}
        </a>
      </React.Fragment>)}
  </div>;
const BlogFooterEmailSection = () => {
  const currentYear = new Date().getFullYear();
  return <div className="footer-email-signup-container border-0 border-solid border-gray-200 md:flex flex-col gap-y-6 items-center justify-between px-4 py-6 w-full xl:border-t" data-sentry-component="BlogFooterEmailSection" data-sentry-source-file="index.tsx">
      <div className="flex flex-col items-center">
        <h4 className="font-bold leading-[30px] max-w-[400px] p-0 text-2xl text-center mb-6">
          Enter your email to receive coupon codes and more!
        </h4>
        <BlogFooterEmail data-sentry-element="BlogFooterEmail" data-sentry-source-file="index.tsx" />
      </div>
      <div className="footer-email-contact-links flex flex-col items-center">
        <p className="mb-0 text-gray-500 text-base">
          All content © {currentYear} WebstaurantStore
        </p>
        <LinkList links={links} data-sentry-element="LinkList" data-sentry-source-file="index.tsx" />
      </div>
    </div>;
};
export default BlogFooterEmailSection;